module.exports = __webpack_public_path__ + "media/TechAlliance.6f7b44f6.mp4";